import 'vuesax/dist/vuesax.css'
import 'material-icons/iconfont/material-icons.scss'
import '@/assets/styles/vuesax.scss'

import Vue from 'vue'
import VueSax from 'vuesax'

Vue.use(VueSax, {
  theme: {
    colors: {
      primary: '#493493',
      'primary-accent': '#836ADA',
      secondary: '#0B9DDE',
      success: '#6dd400',
      warning: '#f7b500',
      danger: '#ec1d1d',
      dark: '#242145',
      black: '#121212',
      white: '#ffffff',
      'grey-001': '#aaaaaa',
      'grey-002': '#dedede',
      'grey-003': '#ebedf8',
      'grey-004': '#f5f6fE'
    }
  }
})
